"use strict";

/**
* Диалог множественного выбора c поддержкой сортировки.
*
* @class WebAccess.components.dialogs.SelectableMultiSelect
* @extends WebAccess.components.dialogs.BaseMultiSelect

* @param {array<WebAccess.components.dialogs.BaseMultiSelect.multiSelectItem>} availableItems Список доступных элементов, в том числе элементы, которые были выбраны. Отображаются в левой части диалогового окна
* @param {array<WebAccess.components.dialogs.BaseMultiSelect.multiSelectItem>} [opt_selectedItems] Список выбранных элементов. Отображаются в правой части диалогового окна
* @param {object} [opt_settings] Настройки диалогового окна
*/
(function (global) {
  var SelectableMultiSelect = global.BaseMultiSelect.extend({
    init: function (availableItems, opt_selectedItems, opt_settings) {
      var instance = this;
      this._displayOptions = false;
      this._super(availableItems, opt_selectedItems, opt_settings);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализация событий
     * Здесь сделаем, так что при смене сортировки данные будут считаться измененными.
     * @private
     */
    _initEvents: function () {
      this._super();

      this.bind("sortingChanged", function () {
        this.isSelectionChanged = true;
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установки параметров колонок таблицы с выбранными элементами.
     * В данном случае есть 3-й столбец
     * Для мобильных браузеров проще и эффективнее задавать ширину в процентах
     * @private
     * @return {array} параметры колонок
     */
    _getColumnsInfo: function () {
      var cols = [];
      if (WA.ENV.isMobile()) {
        if (!this.isReadonly) {
          //cols.push({ "bVisible": true, "sWidth": "15px", "bSortable": false });
          //cols.push({ "bVisible": true, "sWidth": "360px", "bSortable": false });
          //cols.push({ "bVisible": true, "sWidth": "30px", "bSortable": false });

          cols.push({ "bVisible": true, "sWidth": "8%", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "92%", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        } else {
          cols.push({ "bVisible": false, "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "100%", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        }
      } else {
        if (!this.isReadonly) {
          cols.push({ "bVisible": true, "sWidth": "14px", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "399px", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        } else {
          cols.push({ "bVisible": false, "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "447px", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        }
      }
      return cols;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Кнопки вверх и вниз.
    * Навешиваем на них обработчики.
    * Когда нажимем на кнопку и нет ни одной выделенной записи среди выбранных,
    * то сами выделяем.
    * @private
    */
    _initExtraEvents: function () {
      var me = this;
      $(document).not("#move_up, #move_down").bind('click', function (e) {
        $("#selectedRecordsTable tr").removeClass("marked");
      });

      $("#move_up").on("click", function (e) {
        e.stopPropagation();
        var jMarkedRow = $("#selectedRecordsTable tr.marked");
        if (jMarkedRow.length > 0) {
          me._swapRows(jMarkedRow, "up");
        } else {
          $("#selectedRecordsTable tbody tr:first").addClass("marked");
        }
      });
      $("#move_down").on("click", function (e) {
        e.stopPropagation();
        var jMarkedRow = $("#selectedRecordsTable tr.marked");
        if (jMarkedRow.length > 0) {
          me._swapRows(jMarkedRow, "down");
        } else {
          $("#selectedRecordsTable tbody tr:first").addClass("marked");
        }
      });

      //setTimeout(function () { $("#selectedRecordsTable tbody tr:first").addClass("marked") }, 0);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Строит html для области с выбранными записями.
    * @private
    */
    _prepareSelectedItemsArea: function () {
      var renderedItems = "";

      for (var i = 0, l = this.selectedItems.length; i < l; i++) {
        var selected = this._renderSelectedItem(this.selectedItems[i]);
        renderedItems += selected;
      }

      var displayDelete = this.isReadonly ? 'hidden' : '';
      var displayOptions = !this._displayOptions || this.isReadonly ? 'hidden' : '';

      this._html += format(CT.dialog.selectedItemsArea, {
        label: this.selectedItemslabel,
        extra_attributes: 'style="width: 490px"',
        name: L("NAME"),
        data: renderedItems,
        display_delete: displayDelete,
        display_options: displayOptions,
        option_name: "",
        area_class: 'stat_SelectedItems'
      });
      this._html += CT.dialog.sortButtons;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * параметры отрисовки выбранного элемента. В данном случае у нас добавился еще один столбец option
     * @param  {object} item элемент массива выбранных пунктов
     * @private
     * @return {string} разметка элемента
     */
    _renderSelectedItem: function (item) {
      item["items_mode"] = "";
      item["display_delete"] = this.isReadonly ? 'hidden' : '';
      item["delete_title"] = L("DELETE");
      item["extra_attributes"] = 'style="text-decoration: none;"';
      item["display_options"] = this.isReadonly ? 'hidden' : 'hidden';
      item["url"] = item["url"] || "#";

      //      item["name"] = escapeHtml(item["name"]);

      //if (!WA.ENV.isAndroid() && !$.ipad) var visibility = 'hidden';
      //item["option"] = format(CT.dialog.sortingButtons, { 'is_hidden': visibility });

      return format(CT.dialog.selectedItem, item);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Навешиваем события на выбранный пункт
     * @param  {string} rowSelector [description]
     * @private
     */
    _initSingleSelectedItemEvents: function (rowSelector) {
      this._super(rowSelector);
      var instance = this;

      var jRow = $(rowSelector);
      if (!$.ipad && !WA.ENV.isAndroid()) {
        jRow.hover(
            function () {
              $(this).find('.itemUp').removeClass("hidden");
              $(this).find('.itemDown').removeClass("hidden");
            },
            function () {
              $(this).find('.itemUp').addClass('hidden');
              $(this).find('.itemDown').addClass('hidden');
            }
        );
      }

      jRow.on('click', this, function (e) {
        e.stopPropagation();
        $("#selectedRecordsTable tr").not(this).removeClass("marked");
        $(this).addClass("marked");
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /**
     * Смена элементов местами
     * @param  {string} itemSelector пункт меню который будет перемещатся
     * @param  {string} ["up"|"down"] direction    направление перемещения
     * @private
     */
    _swapRows: function (jRow, direction) {
      var jPair;

      var id = jRow.attr('id');
      var index = this._getSelectedItemById(id);
      var tmp;

      if (index > 0 && direction == "up") {
        jPair = jRow.prev();
        jPair.before(jRow);

        setTimeout(function () {
          jRow.trigger('mouseover');
        }, 50);

        tmp = this.selectedItems[index - 1];
        this.selectedItems[index - 1] = this.selectedItems[index];
        this.selectedItems[index] = tmp;
        this.fire("sortingChanged");
      }

      if (index < this.selectedItems.length - 1 && direction === "down") {
        jPair = jRow.next();
        jPair.after(jRow);
        setTimeout(function () {
          jRow.trigger('mouseover');
        }, 50);

        tmp = this.selectedItems[index + 1];
        this.selectedItems[index + 1] = this.selectedItems[index];
        this.selectedItems[index] = tmp;
        this.fire("sortingChanged");
      }
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.SelectableMultiSelect = SelectableMultiSelect;
})(window.WebAccess.components.dialogs);
